(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }
  customElements.define('cart-note', CartNote);

  document.addEventListener('DOMContentLoaded', function () {
    // Ensure placeholder is visible when empty
    var noteField = document.getElementById('Cart-note');
    if (noteField && (!noteField.value || !noteField.value.trim())) {
      noteField.value = '';
      noteField.setAttribute('placeholder', 'Fx: Må stilles ved hoveddør / i carporten');
    }

    // Required note validation on form submit
    var cartForm = document.getElementById('cart');

    if (cartForm && noteField) {
      cartForm.addEventListener('submit', function (e) {
        // MAIN VALIDATION — block checkout
        if (!noteField.value.trim()) {
          e.preventDefault();
          alert(
            'Angiv venligst leveringsinstruktioner (hvor må pakken stilles, hvis du ikke er hjemme).'
          );
          noteField.focus();
          return false;
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
